import { z } from 'zod';

export const projectDto = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  publicKey: z.string(),
  activeLanguages: z.array(z.string().length(2)),
  primaryUrl: z.string().nullable(),
  status: z.enum(['active', 'suspended']),
  journeyCount: z.number().int(),
  publishedGuidanceCount: z.number().int(),
  createdAt: z.string().datetime(),
});
export type ProjectDto = z.infer<typeof projectDto>;

export const createProjectDto = z
  .object({
    name: z.string().min(1).max(100),
    activeLanguages: z.array(z.string().length(2)).min(1),
    primaryUrl: z.string().url().nullable().default(null),
  })
  .strict();
export type CreateProject = z.infer<typeof createProjectDto>;
